import { ReactNode } from "react";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  variant?: "default" | "gradient" | "dark";
  align?: "left" | "center";
}

export function PageHero({
  title,
  subtitle,
  children,
  variant = "gradient",
  align = "center",
}: PageHeroProps) {
  const bgClasses = {
    default: "bg-secondary",
    gradient: "gradient-hero relative overflow-hidden",
    dark: "section-dark",
  };

  const subtitleClasses = {
    default: "text-muted-foreground",
    gradient: "text-muted-foreground",
    dark: "text-primary-foreground/80",
  };

  const alignClasses = align === "center" ? "text-center" : "text-left";

  return (
    <section className={`py-12 sm:py-16 md:py-20 lg:py-24 ${bgClasses[variant]}`}>
      {/* Decorative elements for gradient variant */}
      {variant === "gradient" && (
        <>
          <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 sm:w-64 h-48 sm:h-64 bg-accent/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
        </>
      )}
      <div className={`container-wide relative z-10 ${alignClasses}`}>
        <h1 className="text-display font-bold mb-4 sm:mb-6 max-w-4xl mx-auto text-balance">
          {title}
        </h1>
        {subtitle && (
          <p className={`text-body-lg max-w-2xl ${align === "center" ? "mx-auto" : ""} ${subtitleClasses[variant]}`}>
            {subtitle}
          </p>
        )}
        {children && <div className="mt-6 sm:mt-8">{children}</div>}
      </div>
    </section>
  );
}
